import { render } from "./News.vue?vue&type=template&id=08af52c4"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
script.render = render

export default script
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QPagination,QTooltip,QSelect,QTable,QTr,QTd});
